import {ChangeDetectorRef, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {StudyProgrammeDto} from '../../../forms/modules/sp/models/osp';

@Pipe({
  name: 'filterStudyProgrammeSearch',
})
export class FilterStudyProgrammeSearchPipe implements PipeTransform {
  constructor(private cdr: ChangeDetectorRef, private translate: TranslateService) {
  }

  transform(items: StudyProgrammeDto[], searchText: string, state: number, spFilterMetadata): StudyProgrammeDto[] {
    if (!items) {
      spFilterMetadata.count = 0;
      this.cdr.detectChanges();
      return [];
    }
    items = items.filter((programme: StudyProgrammeDto) => {
      return programme.state === state;
    });
    if (!searchText) {
      spFilterMetadata.count = items.length;
      this.cdr.detectChanges();
      return items;
    }
    searchText = searchText.toLowerCase();

    const filteredItems = items.filter((programme: StudyProgrammeDto) => {
      const text = programme.title + ' ' + programme.faculty.name + ', ' + this.translate.instant('dashboard.study_programme_part.sp_subtitle.study_field') +
        programme.studyField + (programme.studyField2 ? '+' + programme.studyField2 : '') + ', ' + programme.degree + ' ' +
        this.translate.instant('dashboard.study_programme_part.sp_subtitle.degree') + ', ' +
        (programme.formOfStudy === 'PRESENT' ? this.translate.instant('forms.osp.tabs.basic_data.section.basic_data.input.form_of_study.present') :
          this.translate.instant('forms.osp.tabs.basic_data.section.basic_data.input.form_of_study.external'));
      return text.toLowerCase().indexOf(searchText) !== -1;
    });
    spFilterMetadata.count = filteredItems.length;
    this.cdr.detectChanges();
    return filteredItems;
  }
}
